__webpack_require__.p = "/clube/parceiros/_next/";